<template>
    <div class="dropdown-divider"></div>
</template>
